import React from 'react';
import './styles.scss'
import { Card, Accordion } from 'react-bootstrap';
import { areIntervalsOverlapping, differenceInCalendarDays, differenceInMilliseconds, isBefore } from 'date-fns';
import { informationOfTheDay } from '../../utils';

function EPGProgramList({
    epgItemCollection,
    renderItem,
    renderItemBody,
    selectedDay,
    selectedEpgId,
    setCollapseExpanded,
    enableEpgDropdown
}) {

    const [result, setResult] = React.useState([]);

    React.useEffect(() => {
        const { from, to, totalMilliseconds: totalMillisecondsDay } = informationOfTheDay(selectedDay)

        const resultFilter = [];
        let indexFrom = from;
        try {
            epgItemCollection.epg.forEach((programItem) => {

                let endTime = new Date(programItem.endTime);
                let startTime = new Date(programItem.startTime);

                // Si el contenido no sucede en el día seleccionado, no se guarda.
                if (!theContentHappensInTheDay({ from: from, to: to }, { startTime: startTime, endTime: endTime })) return;

                // Si startTime es anterior al (from) del día seleccionado, lo seteamos a comienzo del día seleccionado. (0hs)
                if (differenceInCalendarDays(startTime, new Date(selectedDay))) startTime = from;
                // Si endTime es posterior al (to) del día seleccionado, lo seteamos al final del día seleccionado. (24hs)
                if (differenceInCalendarDays(endTime, new Date(selectedDay))) endTime = to;


                const percentageOfTimeNoContent = calculatePercentage(startTime, indexFrom, totalMillisecondsDay)

                // Si el contenido no empieza cuando finaliza el contenido anterior, lo completamos con bloques sin contenido.
                if (startTime !== indexFrom && percentageOfTimeNoContent > 0) fillNoContentByDefault(resultFilter, percentageOfTimeNoContent);

                const percentageOfTimeContent = calculatePercentage(endTime, startTime, totalMillisecondsDay)

                // Guardamos el contenido.
                resultFilter.push({
                    content: { ...programItem },
                    percentageOfTime: percentageOfTimeContent,
                    //startLineTime: Math.abs((1 / totalMillisecondsSelectedDay) * differenceInMilliseconds(from, startTime))
                });

                /* 
                    Se guarda el endTime como index para tener de referencia en el proximo contenido.
                    Esto nos sirve para saber cuando hay que poner 'bloques sin contenido' entre medio de los contenidos.
                */
                indexFrom = endTime;
            });

            if (resultFilter.length > 0) {
                const endTimeContent = new Date(resultFilter[resultFilter.length - 1]?.content?.endTime);
                const percentageOfTimeNoContent = calculatePercentage(endTimeContent, to, totalMillisecondsDay);
                // Si el ultimo contenido termina antes del final del dia selecionado, lo llenamos de bloques sin contenido.
                if (isBefore(endTimeContent, to) && percentageOfTimeNoContent > 0) fillNoContentByDefault(resultFilter, percentageOfTimeNoContent);
            }

            if (resultFilter.length === 0) {
                // Si no hay contenido en el día, lo llenamos de bloques sin contenido
                if (resultFilter.length === 0) fillNoContentByDefault(resultFilter, 100, 10);
            }

            setResult(resultFilter);
        } catch (e) {
            console.error('>>>>>> EPGProgramList error', e);
            setResult([]);
        }
    }, [epgItemCollection])



    const fillNoContentByDefault = (resultFilter, percentageOfTimeNoContent, intervalInPercent = 5) => {
        let percentageOfTimeNoContentHelp = percentageOfTimeNoContent;
        let percentageCount = 0;

        while (percentageOfTimeNoContentHelp > intervalInPercent) {
            percentageOfTimeNoContentHelp /= 2;
        }

        while (percentageCount < percentageOfTimeNoContent) {
            resultFilter.push({
                percentageOfTime: percentageOfTimeNoContentHelp,
                keyNoContent: Math.floor(Math.random() * 65536) + '-' + percentageOfTimeNoContentHelp // React key
                //startLineTime: Math.abs((1 / totalMillisecondsSelectedDay) * differenceInMilliseconds(from, indexFrom))
            });

            percentageCount += percentageOfTimeNoContentHelp;
        }
    }


    const theContentHappensInTheDay = (day, content) => {
        const { from, to } = day;
        const { startTime, endTime } = content;
        return (areIntervalsOverlapping(
            { start: from, end: to },
            { start: startTime, end: endTime },
            { inclusive: false }
        ))
    }


    const calculatePercentage = (from, to, totalMilliseconds) => {
        const totalMillisecondsDate = parseInt(differenceInMilliseconds(from, to));
        return Math.abs(totalMillisecondsDate) / totalMilliseconds * 100;
    }



    return (
        <Card className='epgGridList_row_card' >
            <Card.Header className='epgGridList_row_header'>
                {result.map(({ content, percentageOfTime, startLineTime, keyNoContent }) => renderItem(content, epgItemCollection.epgId, percentageOfTime, startLineTime, epgItemCollection, keyNoContent, selectedEpgId))}
            </Card.Header>
            { enableEpgDropdown && <Accordion.Collapse
                className='epgGridList_row_collapse'
                eventKey={epgItemCollection.epgId}
                onEntered={(props) => setCollapseExpanded(true,props.offsetHeight)}
                onExited={(props) => setCollapseExpanded(false,props.offsetHeight)}
                >
                <Card.Body className='epgGridList_row_collapse_body' style={{ padding: 0 }}>{
                    selectedEpgId === epgItemCollection.epgId && renderItemBody(epgItemCollection)
                }</Card.Body>
            </Accordion.Collapse> }
        </Card>
    );
};

export default React.memo(EPGProgramList);



